import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import { HeaderBar, FooterBar } from './components';

import Home from './pages/Home/Home.js';
import PublicPage from './pages/PublicPage/PublicPage.js';
import LoginPage from './pages/Login/Login.js';


function App() {
  return (
    <BrowserRouter>
      <div className="bsat312-container">
        <HeaderBar />

        <main className="bsat312-body">
          <Routes>
            <Route path='/'        element={<Home />} />
            <Route path='/about'   element={<PublicPage pagename='about' />} />
            <Route path='/join'    element={<PublicPage pagename='join' />} />
            <Route path='/contact' element={<PublicPage pagename='contact' />} />
            <Route path='/login'   element={<LoginPage />} />
          </Routes>
        </main>

        <FooterBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
